import { MaterialUICore } from '@iclinic/design-system';

const { styled } = MaterialUICore;

export const TableContainer = styled(MaterialUICore.TableContainer)({
  height: '570px',
});
